document.addEventListener('DOMContentLoaded', () => {
  const customCss = `
    section[data-sizing="form-wrapper"][class^="_formContainer"] {
      @media screen and (max-width: 768px) {
        grid-template-rows: 260px min-content;
      }
    }
    section[data-sizing="form-wrapper"][class^="_formContainer"] div[class*="_imageLoaded"] {
      @media screen and (max-width: 768px) {
        background-position: bottom;
      }
    }
    section[class^="_formHeader"] h2[class^="_textHeading"] {
      font-size: 18px;
      font-weight: 700;
      margin-top: 10px;
      margin-bottom: 20px;

      @media screen and (max-width: 768px) {
        margin-top: 0;
        margin-bottom: 40px;
      }
    }
    section[class^="_formHeader"] h2[class^="_textHeading"] + div[class^="_textBody"] p {
      font-size: 12px;
      font-weight: 400;
    }
  `;

  const targetNode = document.body;

  const injectStyleToShadowRoot = (element) => {
    if (element.shadowRoot.querySelector('#custom-form-style')) return;

    const styleEl = document.createElement('style');
    styleEl.id = 'custom-form-style';
    styleEl.textContent = customCss;

    element.shadowRoot.appendChild(styleEl);
  };

  const handleFoundEmbed = (element) => {
    if (element.shadowRoot) {
      injectStyleToShadowRoot(element);
    } else {
      setTimeout(() => {
        if (element.shadowRoot) injectStyleToShadowRoot(element);
      }, 100);
    }
  };
  const observer = new MutationObserver((mutationsList, observer) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            if (node.tagName.toLowerCase() === 'shopify-forms-embed') {
              handleFoundEmbed(node);
              observer.disconnect();
            }
            else {
              const embed = node.querySelector('shopify-forms-embed');
              if (embed) {
                handleFoundEmbed(embed);
                observer.disconnect();
              }
            }
            
          }
        });
      }
    }
  });

  observer.observe(targetNode, { childList: true, subtree: true });
});